import axios from 'axios'
import {AuthModel, UserModel} from './_models'

// v2 FastAPI backend (fds-v2). REACT_APP_API_URL is the API origin; the v2
// routes live at /auth/* and /users/* under it.
const AUTH_API_URL = process.env.REACT_APP_API_URL + '/auth'
const USERS_API_URL = process.env.REACT_APP_API_URL + '/users'

// Registration / forgot-password are not routed in this app (see AuthPage.tsx:
// registration redirects to the old Flask app, forgot-password is commented
// out), so these two stay pointed at the legacy Flask API.
const LEGACY_USERS_API_URL = process.env.REACT_APP_OLD_FLASK_APP_URL + '/api/users'

export const GET_USER_BY_ACCESSTOKEN_URL = `${USERS_API_URL}/profile`
export const LOGIN_URL = `${AUTH_API_URL}/login`
export const REGISTER_URL = `${LEGACY_USERS_API_URL}/register`
export const REQUEST_PASSWORD_URL = `${LEGACY_USERS_API_URL}/forgot_password`
export const GET_JWT_TOKEN = `${AUTH_API_URL}/exchange-api-token`

// Server should return AuthModel
export async function login(email: string, password: string) {
  const response = await axios.post<AuthModel>(LOGIN_URL, {email, password})

  if (!response.data?.access_token) {
    // MFA-enabled companies get an mfa_pending_token here instead of tokens.
    // This app has no MFA screens — those users sign in through the main FDS
    // app and land here via SSO.
    throw new Error('MFA sign-in is not supported here. Please sign in through the main FDS app.')
  }

  return response
}

// Server should return AuthModel
export function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string
) {
  return axios.post(REGISTER_URL, {
    email,
    firstname: firstname,
    lastname: lastname,
    password,
    password_confirmation,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{result: boolean}>(REQUEST_PASSWORD_URL, {
    email,
  })
}

export function getUserByToken(token: string) {
  // Legacy /users/verify_token took the token as a form field; the v2
  // /users/profile endpoint reads it from the Authorization header.
  return axios.get<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
    headers: {Authorization: `Bearer ${token}`},
  })
}

export function getJwtToken(token: string) {
  // v2 /auth/exchange-api-token: JSON body, replaces /users/get_jwt_token.
  return axios.post<AuthModel>(GET_JWT_TOKEN, {api_token: token})
}
